import React from 'react'

const DepartmentHeads = () => {
  return (
    <div className='mx-auto p-4'>
      DepartmentHeads
    </div>
  )
}

export default DepartmentHeads
